import { Card as AntdCard } from "antd";
import type { CardProps } from "antd";

type CardChildrenProps = {
  style?: React.CSSProperties;
  children: React.ReactNode;
};

export const Card = (props: CardProps) => {
  return (
    <AntdCard
      styles={{
        root: {
          border: "1px solid #e9e9e9",
        },
        title: {
          fontWeight: 700,
        },
      }}
      {...props}
    />
  );
};

export const CardHeader = ({ style, children }: CardChildrenProps) => (
  <div
    style={{
      paddingLeft: "2.5rem",
      paddingRight: "1.25rem",
      paddingTop: "1.25rem",
      paddingBottom: "1.25rem",
      borderBottom: "1px solid #e5e5e5",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      ...style,
    }}
  >
    {children}
  </div>
);

export const CardTitle = ({ style, children }: CardChildrenProps) => (
  <h2
    style={{
      marginRight: "auto",
      fontWeight: 700,
      fontSize: "1.125rem",
      ...style,
    }}
  >
    {children}
  </h2>
);

export const CardSubtitle = ({ style, children }: CardChildrenProps) => (
  <p
    style={{
      marginRight: "auto",
      color: "#a3a3a3",
      fontSize: "1rem",
      ...style,
    }}
  >
    {children}
  </p>
);

export const CardContent = ({ style, children }: CardChildrenProps) => (
  <div
    style={{
      paddingLeft: "2.5rem",
      paddingRight: "2.5rem",
      paddingTop: "1.25rem",
      paddingBottom: "1.25rem",
      ...style,
    }}
  >
    {children}
  </div>
);

export const CardFooter = ({ children }: { children: React.ReactNode }) => (
  <div
    style={{
      display: "flex",
      marginLeft: "-42px",
      marginRight: "-42px",
      marginTop: "2.5rem",
      borderTop: "1px solid #f5f5f5",
      paddingTop: "1.25rem",
      paddingLeft: "42px",
      paddingRight: "42px",
      gap: "0.5rem",
    }}
  >
    {children}
  </div>
);
